<div
  class='op-merge-request--title'
  [textContent]="mergeRequest.title"
></div>

<span class='op-merge-request--state' [ngClass]="'op-merge-request--state_' + state">

  @if (state === 'open') {
    <svg op-gitlab-merge-request-open-icon size="small"></svg>
  }
  @if (state === 'ready') {
    <svg op-gitlab-merge-request-ready-icon size="small"></svg>
  }
  @if (state === 'merged') {
    <svg op-gitlab-merge-request-merged-icon size="small"></svg>
  }
  @if (state === 'closed') {
    <svg op-gitlab-merge-request-closed-icon size="small"></svg>
  }

  {{state}} |
  <a
    [ngClass]="'op-merge-request--link_' + state"
    [href]="mergeRequest.htmlUrl"
    target="blank"
    [textContent]="mergeRequest.repository + '#' + mergeRequest.number"
  ></a>
</span>

@if (mergeRequest.labels && mergeRequest.labels.length > 0) {
  <button (click)="toggleLabels(mergeRequest.number)" class='op-merge-request--label_icon' title="Show/Hide labels">
    <svg class="op-merge-request--label_icon_style" op-gitlab-labels-icon size="small"></svg>
  </button>
}

@if (mergeRequest.pipelines && mergeRequest.pipelines.length > 0) {
  <span class='op-merge-request--pipeline-icon'
    [ngClass]="'op-merge-request--pipeline-icon_bg_' + mergeRequest.pipelines[0].status">
    @if (isCurrentPipelinestate('failed')) {
      <svg [ngClass]="pipelineIconClass" op-gitlab-pipeline-status-failed-icon size="small"></svg>
    }
    @if (isCurrentPipelinestate('canceled')) {
      <svg [ngClass]="pipelineIconClass" op-gitlab-pipeline-status-canceled-icon size="small"></svg>
    }
    @if (isCurrentPipelinestate('created')) {
      <svg [ngClass]="pipelineIconClass" op-gitlab-pipeline-status-created-icon size="small"></svg>
    }
    @if (isCurrentPipelinestate('manual')) {
      <svg [ngClass]="pipelineIconClass" op-gitlab-pipeline-status-manual-icon size="small"></svg>
    }
    @if (isCurrentPipelinestate('pending')) {
      <svg [ngClass]="pipelineIconClass" op-gitlab-pipeline-status-pending-icon size="small"></svg>
    }
    @if (isCurrentPipelinestate('preparing')) {
      <svg [ngClass]="pipelineIconClass" op-gitlab-pipeline-status-preparing-icon size="small"></svg>
    }
    @if (isCurrentPipelinestate('running')) {
      <svg [ngClass]="pipelineIconClass" op-gitlab-pipeline-status-running-icon size="small"></svg>
    }
    @if (isCurrentPipelinestate('scheduled')) {
      <svg [ngClass]="pipelineIconClass" op-gitlab-pipeline-status-scheduled-icon size="small"></svg>
    }
    @if (isCurrentPipelinestate('skipped')) {
      <svg [ngClass]="pipelineIconClass" op-gitlab-pipeline-status-skipped-icon size="small"></svg>
    }
    @if (isCurrentPipelinestate('success')) {
      <svg [ngClass]="pipelineIconClass" op-gitlab-pipeline-status-success-icon size="small"></svg>
    }
    @if (isCurrentPipelinestate('waiting')) {
      <svg [ngClass]="pipelineIconClass" op-gitlab-pipeline-status-waiting-icon size="small"></svg>
    }
    <span class='op-merge-request--pipeline-label' [ngClass]="'op-merge-request--pipeline-label_' + mergeRequest.pipelines[0].status"> {{ mergeRequest.pipelines[0].status }} </span>
  </span>
}

<div class="op-merge-request--info_created">
  {{ text.label_created_by }}
  <span class='op-merge-request--user'>
    @if (mergeRequest.gitlabUser) {
      <a
        [href]="'mailto:' + mergeRequest.gitlabUser.email"
        class='op-merge-request--username'
        [textContent]="mergeRequest.gitlabUser.login"
      ></a>
      }.
    </span>
    <span class='op-merge-request--date'>
      {{ text.label_last_updated_on }}
      <op-date-time [dateTimeValue]="mergeRequest.gitlabUpdatedAt" />
    </span>.
  </div>

  <div
    class="op-merge-request--labels"
    [ngClass]="'op-merge-request--labels-' + mergeRequest.number" style="display: none;">
    @for (label of mergeRequest.labels; track label) {
      <span>
        <span class='op-merge-request--label' [ngStyle]="{'background-color': label.color}" >
          {{label.title}}
        </span>
      </span>
    }
  </div>
